<script>
import axios from "axios";
import {toast} from "vue3-toastify";
import ImportStudents from "./import-students.vue";
import VyukaForm from "@/components/ll/vyuka-form.vue";
import LessonInstance from "@/components/ll/lesson-instance.vue";
import AdminCreditHistoryModal from "./admin-credit-history-modal.vue";
import OjPagination from "../OjPagination.vue";

export default {
  name: "my_students",
  props: ['btyp', 'admin', 'currentuser'],
  components: {LessonInstance, VyukaForm, ImportStudents, AdminCreditHistoryModal, OjPagination },
  data() {
    return {
      lessons: [],
      companies:[],
      current_lesson: null,
      lector_options: [],
      selectedCompany: null,
      selectedLector: null,
      selectedTypeLesson: null,
      credit_range: '',
      searchQuery: '',
      searchGroupName: '',
      searchDebounceTimer: null,
      zaskok: 'm', // Default to "my lessons"
      activeStatus: '', // Filter for active/inactive status
      // Pagination
      page: 1,
      per: 50,
      total: 0,
      // Preferred time display mappings
      preferredTimeShortLabels: {
        'weekday_morning': 'WD AM',
        'weekday_afternoon': 'WD PM',
        'weekday_evening': 'WD PM',    // back-compatibility, no longer selectable
        'weekend': 'WE'
      },
      preferredTimeFullLabels: {
        'weekday_morning': 'Weekday morning',
        'weekday_afternoon': 'Weekday afternoon',
        'weekday_evening': 'Weekday evening',
        'weekend': 'Weekend'
      }
    };
  },
  mounted() {
    this.loadStudents();
  },
  watch: {
    selectedCompany() { this.page = 1; this.loadStudents(); },
    selectedLector() { this.page = 1; this.loadStudents(); },
    selectedTypeLesson() { this.page = 1; this.loadStudents(); },
    credit_range() { this.page = 1; this.loadStudents(); },
    activeStatus() { this.page = 1; this.loadStudents(); },
    zaskok() { this.page = 1; this.loadStudents(); },
    per() { this.page = 1; this.loadStudents(); }
  },
  methods: {
    handleEditLesson(lesson) {
        this.current_lesson = lesson;
        // Předpokládáme, že máte komponentu pro úpravu lekce
        // Můžete zde otevřít modální okno nebo přesměrovat
      this.$refs.formVyuka.showModal();

    },
    handleNewLessonInstance(lesson) {
      console.log('Attempting to add new lesson instance for lesson', lesson.id, 'Accounting type:', lesson.accounting_type, 'Credit:', lesson.credit, 'Instances count:', lesson.instances_count, 'Instances this month:', lesson.instances_count_this_month);
      // Kontrola accounting limits podle typu systému
      if (lesson.accounting_type === 'credit_based' && (lesson.credit <= 0 || lesson.credit <= lesson.instances_count)) {
        toast.error("Student has no credit!");
        return;
      }
      
      if (lesson.accounting_type === 'lessons_per_month') {
        const currentCount = lesson.instances_count_this_month || 0;
        if (currentCount >= lesson.lessons_per_month) {
          toast.error(`This month's lesson limit has been exceeded (${currentCount}/${lesson.lessons_per_month})`);
          return;
        }
      }
      
      // Pro flexible - vždy povolit
      this.current_lesson = lesson;
      this.$refs.formLessonInstance.showModal();

    },


    loadStudents() {
      const url = '/ll/students/lessons.json';
      axios.get(url, {
        params: {
          btyp: this.btyp,
          company_id: this.selectedCompany,
          lector_id: this.selectedLector,
          lesson_type: this.selectedTypeLesson,
          credit_range: this.credit_range,
          search_query: this.searchQuery,
          group_name: this.searchGroupName,
          zaskok: this.zaskok,
          active_status: this.activeStatus,
          page: this.page,
          per: this.per
        }
      })
          .then(response => {
            this.lessons = response.data.lessons;
            this.companies = response.data.companies;
            this.lector_options = response.data.lectors;
            this.total = response.data.total;
          })
          .catch(error => {
            console.error('Došlo k chybě při načítání lekcí:', error);
          });
    },
    handleSearchInput() {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.page = 1;
        this.loadStudents();
      }, 500);
    },
    handleGroupNameInput() {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.page = 1;
        this.loadStudents();
      }, 500);
    },
    handleImportSuccess() {
      this.loadStudents();
    },
    showImportModal() {
      this.$refs.importStudentsComponent.showModal();
    },
    addVyuka() {
      this.current_lesson = {
        students: [],
        lector: null,
        lesson_type: 'one_to_one',
        language_level: '',
        preferred_time: '',
        preferred_times: [],
        minutes: 0,
        lessons_per_month: 0,
        credit: 0,
        change_credit:0
      };
      this.$refs.formVyuka.showModal();
    },
    handleSaveLesson(lesson) {
      this.loadStudents();
    },
    pageChanged(p) {
      this.page = p;
      this.loadStudents();
    },
    showCreditHistory(lesson) {
      this.$refs.creditHistoryModal.open(lesson.id);
    },
    handleDeleteLesson(lesson) {
      const studentNames = lesson.students.map(s => `${s.name} ${s.surname}`).join(', ');
      const confirmMessage = `Are you sure you want to delete this lesson?\n\nStudents: ${studentNames}\nLesson type: ${lesson.lesson_type_name}\n\nThis action cannot be undone and will remove all lesson history, instances, and credit transfers.`;

      if (confirm(confirmMessage)) {
        axios.delete(`/ll/students/lessons/${lesson.id}`)
          .then(() => {
            toast.success('Lesson deleted successfully');
            this.loadStudents();
          })
          .catch(error => {
            console.error('Error deleting lesson:', error);
            toast.error('Error deleting lesson');
          });
      }
    },
    
    getPreferredTimeBadgeClass(preferredTimeKey) {
      const badgeClasses = {
        'weekday_morning': 'badge-warning',     // Yellow
        'weekday_afternoon': 'badge-info',      // Blue
        'weekday_evening': 'badge-purple',      // Purple (custom)
        'weekend': 'badge-success'              // Green
      };
      return badgeClasses[preferredTimeKey] || 'badge-secondary';
    },

    // Kontrola, zda lze přidat novou lekci
    canAddLessonInstance(lesson) {
      // Credit-based systém
      if (lesson.accounting_type === 'credit_based') {

        //console.log('Checking credit for lesson', lesson.id, 'Credit:', lesson.credit, lesson);


        return lesson.credit > lesson.instances_count;
      }
      
      // Lessons per month systém
      if (lesson.accounting_type === 'lessons_per_month') {
        const currentCount = lesson.instances_count_this_month || 0;
        return currentCount < lesson.lessons_per_month;
      }
      
      // Flexible - vždy povolit
      return true;
    },

    // Vrátí zprávu, proč nelze přidat lekci
    getLimitMessage(lesson) {
      if (lesson.accounting_type === 'credit_based' && lesson.credit <= 0) {
        return 'Student has no credit!';
      }
      
      if (lesson.accounting_type === 'lessons_per_month') {
        const currentCount = lesson.instances_count_this_month || 0;
        if (currentCount >= lesson.lessons_per_month) {
          return `This month's lesson limit has been exceeded (${currentCount}/${lesson.lessons_per_month})`;
        }
      }
      
      return 'Add new lesson';
    }
  }
}
</script>

<template>
  <div>
    <h1>{{btyp=='b2b' ? "B2B Corporate Students": "B2C Individual Students" }}</h1>


    <div class="d-flex justify-content-end " style="position:absolute; top:5px; right:0; height:30px;" v-if="admin">
      <button type="button" class="btn btn-primary" @click="showImportModal" v-if="btyp=='b2b'">
        Import Students
      </button>
      <button type="button" class="btn btn-primary" @click="addVyuka">
       Add Lesson
      </button>
    </div>

    <import-students ref="importStudentsComponent" @import-successful="handleImportSuccess"></import-students>
  </div>

  <div class=" card card-body  mt-2">
    <div class="row">
      <div class="col-md-3" >
        <label>Search Student (email or name)</label>
        <input
          type="text"
          class="form-control"
          v-model="searchQuery"
          @input="handleSearchInput"
          placeholder="Enter student email or name"
        >
      </div>

      <div class="col-md-3" v-if="btyp==='b2b'">
        <label>Company</label>
        <select v-model="selectedCompany" class="form-control">
          <option value="">-- Select Company --</option>
          <option v-for="company in companies" :key="company.id" :value="company.id">
            {{ company.name }}
          </option>
        </select>



      </div>

      <div class="col-md-3" v-if="admin">
        <label>Lecturer</label>
        <select v-model="selectedLector" class="form-control">
          <option value="">-- Select Lecturer --</option>
          <option v-for="lector in lector_options" :key="lector.id" :value="lector.id">
            {{ lector.first_name }} {{ lector.last_name }}
          </option>

        </select>

      </div>

      <div class="col-md-3" v-if="!admin">
        <label>Lessons</label>
        <select v-model="zaskok" class="form-control">
          <option value="m">My Lessons</option>
          <option value="all">Enter Substitute</option>
        </select>
      </div>

      <div class="col-md-3" v-if="btyp==='b2b'">
        <label>Lesson Type</label>
        <select class="form-control" v-model="selectedTypeLesson">
          <option></option>
          <option value="one_to_one">One-to-One</option>
          <option value="two_students">Pair Lesson</option>
          <option value="group">Group Lesson</option>
          <option value="minicall">MiniCall</option>

        </select>

      </div>

      <div class="col-md-3" >
        <label>Credit</label>
        <select v-model="credit_range" class="form-control">
          <option value="">All</option>
          <option value="less_than_4">Less than 4 lessons</option>
          <option value="more_than_4">More than 4 lessons</option>
          <option value="no_credit">No credit</option>
        </select>
      </div>

      <div class="col-md-3">
        <label>Status</label>
        <select v-model="activeStatus" class="form-control">
          <option value="">All</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      <div class="col-md-2">
        <label>Per page</label>
        <select v-model.number="per" class="form-control">
          <option :value="20">20</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </div>

    </div>

    <!-- New row for Group Name filter -->
    <div class="row mt-2">
      <div class="col-md-3" v-if="btyp==='b2b'">
        <label>Group Name</label>
        <input
          type="text"
          class="form-control"
          v-model="searchGroupName"
          @input="handleGroupNameInput"
          placeholder=""
        />
      </div>
    </div>




    <OjPagination
        class="m-auto"
        :totalItems="total"
        :currentPage="page"
        :perPage="per"
        @pageChanged="pageChanged"
        :key="`pagination-top-${page}`"
    />

    <table class="table table-bordered mt-2 d-none d-lg-table">

      <thead>
      <tr>
        <th class="th-status">St.</th>
        <th>Student/s</th>
        <th v-if="btyp === 'b2b'">Group</th>
        <th v-if="btyp === 'b2b'">Company</th>
        <th>Lecturer</th>
        <th>Type</th>
        <th>Lang.</th>
        <th>Level</th>
        <th>Pref. time</th>
        <th>Min.</th>
        <th v-if="btyp === 'b2b'">Lessons</th>
        <th>Credit</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="lesson in lessons" :key="lesson.id">
        <td class="text-center td-status">
          <span 
            :class="['badge', 'badge-status', lesson.active ? 'badge-success' : 'badge-danger']"
            :title="lesson.active ? 'Active' : 'Inactive'"
          >
            {{ lesson.active ? 'A' : 'N' }}
          </span>
        </td>
        <td>
          <ul class="list-unstyled mb-0">
            <li v-for="student in lesson.students" :key="student.id">
              <template v-if="admin">
               <a :href="`/students/${student.id}`" target="_blank">{{ student.email }}</a>
              </template>
              <template v-else>
                {{ student.email }}
              </template>
            </li>
          </ul>
        </td>
        <td v-if="btyp === 'b2b'">{{ lesson.group_name || '-' }}</td>
        <td v-if="btyp === 'b2b'">{{ lesson.organization?.name || 'N/A' }}</td>
        <td>{{ lesson.lector ? [lesson.lector.first_name, lesson.lector.last_name].join(' ')  : 'N/A' }}</td>
        <td>{{ lesson.lesson_type_name }}</td>
        <td>{{ lesson.language ? lesson.language.iso_code : 'N/A' }}</td>
        <td>{{ lesson.language_level }}</td>
        <td>
          <template v-if="lesson.preferred_time && lesson.preferred_time.length > 0">
            <span 
              v-for="(timeKey, idx) in lesson.preferred_time.split(',')" 
              :key="idx" 
              :class="['badge', 'badge-preferred-time', 'd-block', 'mb-1', getPreferredTimeBadgeClass(timeKey.trim())]"
              v-b-tooltip.hover
              :title="preferredTimeFullLabels[timeKey.trim()] || timeKey"
            >
              {{ preferredTimeShortLabels[timeKey.trim()] || timeKey }}
            </span>
          </template>
          <span v-else class="text-muted">-</span>
        </td>
        <td>{{ lesson.minutes }}</td>
        
        <!-- Lesson number (B2B only) - with accounting badge for flexible/lessons_per_month -->
        <td v-if="btyp === 'b2b'">
          <div v-if="lesson.accounting_type === 'flexible'">
            <span class="badge badge-info badge-sm">
              <i class="fas fa-infinity"></i> Flexible
            </span>
            <div class="mt-1">{{lesson.instances_count}}</div>

          </div>
          <div v-else-if="lesson.accounting_type === 'lessons_per_month'">
            <span class="badge badge-warning badge-sm">
              <i class="fas fa-calendar-check"></i> Monthly Limit
            </span>
            <div class="mt-1">{{ lesson.instances_count_this_month || 0 }} / {{ lesson.lessons_per_month }}</div>
          </div>
          <span v-else class="text-muted">-</span>
        </td>
        
        <!-- Credit - with accounting badge for credit_based (B2B), always show for B2C -->
        <td>
          <template v-if="lesson.accounting_type === 'credit_based' || btyp === 'b2c'">
            <span v-if="btyp === 'b2b'" class="badge badge-success badge-sm">
              <i class="fas fa-coins"></i> Credit
            </span>
            <div :class="{ 'mt-1': btyp === 'b2b' }">
              {{lesson.instances_count}} /
              <a href="#" 
                 @click.prevent="showCreditHistory(lesson)" 
                 class="credit-link"
                 title="Show Credit History">
                {{lesson.credit}}
              </a>
            </div>
          </template>
          <span v-else class="text-muted">-</span>
        </td>

        <!-- Akce -->
        <td>
          <div class="action-buttons">
            <a v-if="admin" href="#" @click.prevent="handleEditLesson(lesson)" class="btn-icon" title="Edit">
              <i class="fas fa-pencil-alt text-primary"></i>
            </a>
            <a v-if="admin" href="#" @click.prevent="handleDeleteLesson(lesson)" class="btn-icon btn-icon-delete" title="Delete">
              <i class="fas fa-trash-alt"></i>
            </a>
            <a href="#" 
               @click.prevent="handleNewLessonInstance(lesson)" 
               class="btn-add-lesson" 
               :class="{ 'disabled': !canAddLessonInstance(lesson) }"
               :title="canAddLessonInstance(lesson) ? 'Add new lesson' : getLimitMessage(lesson)">
              <i class="fas fa-plus"></i> new
            </a>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <!-- RESPONSIVE CARDS (< 992px) -->
    <div class="responsive-cards d-lg-none mt-2">
      <div v-for="lesson in lessons" :key="'card-'+lesson.id" class="responsive-card">
        <div class="rcard-header">
          <div class="rcard-header-left">
            <span 
              :class="['badge', lesson.active ? 'badge-success' : 'badge-danger']"
              style="font-size:0.7rem; padding:0.15rem 0.35rem;"
            >{{ lesson.active ? 'A' : 'N' }}</span>
            <strong class="rcard-student-name">
              <template v-if="lesson.students && lesson.students.length">
                {{ lesson.students.map(s => s.name ? (s.name + ' ' + (s.surname||'')) : s.email).join(', ') }}
              </template>
            </strong>
          </div>
          <div class="action-buttons">
            <a v-if="admin" href="#" @click.prevent="handleEditLesson(lesson)" class="btn-icon" title="Edit">
              <i class="fas fa-pencil-alt text-primary"></i>
            </a>
            <a v-if="admin" href="#" @click.prevent="handleDeleteLesson(lesson)" class="btn-icon btn-icon-delete" title="Delete">
              <i class="fas fa-trash-alt"></i>
            </a>
            <a href="#" 
               @click.prevent="handleNewLessonInstance(lesson)" 
               class="btn-add-lesson"
               :class="{ 'disabled': !canAddLessonInstance(lesson) }"
               :title="canAddLessonInstance(lesson) ? 'Add new lesson' : getLimitMessage(lesson)">
              <i class="fas fa-plus"></i> Add
            </a>
          </div>
        </div>
        <div class="rcard-body">
          <!-- Student emails -->
          <div class="rcard-row">
            <span class="rcard-label">Email</span>
            <span class="rcard-value">
              <template v-for="student in lesson.students" :key="student.id">
                <a v-if="admin" :href="`/students/${student.id}`" target="_blank">{{ student.email }}</a>
                <span v-else>{{ student.email }}</span>
                <br v-if="lesson.students.length > 1">
              </template>
            </span>
          </div>

          <div class="rcard-row" v-if="btyp === 'b2b' && lesson.organization">
            <span class="rcard-label">Company</span>
            <span class="rcard-value">{{ lesson.organization?.name || '-' }}</span>
          </div>

          <div class="rcard-row" v-if="btyp === 'b2b' && lesson.group_name">
            <span class="rcard-label">Group</span>
            <span class="rcard-value">{{ lesson.group_name }}</span>
          </div>

          <div class="rcard-row">
            <span class="rcard-label">Lecturer</span>
            <span class="rcard-value">{{ lesson.lector ? [lesson.lector.first_name, lesson.lector.last_name].join(' ') : 'N/A' }}</span>
          </div>

          <div class="rcard-row rcard-row-inline">
            <div class="rcard-cell">
              <span class="rcard-label">Type</span>
              <span class="rcard-value">{{ lesson.lesson_type_name }}</span>
            </div>
            <div class="rcard-cell">
              <span class="rcard-label">Lang.</span>
              <span class="rcard-value">{{ lesson.language ? lesson.language.iso_code : '-' }}</span>
            </div>
            <div class="rcard-cell">
              <span class="rcard-label">Level</span>
              <span class="rcard-value">{{ lesson.language_level || '-' }}</span>
            </div>
            <div class="rcard-cell">
              <span class="rcard-label">Min.</span>
              <span class="rcard-value">{{ lesson.minutes }}</span>
            </div>
          </div>

          <div class="rcard-row" v-if="lesson.preferred_time && lesson.preferred_time.length > 0">
            <span class="rcard-label">Pref. time</span>
            <span class="rcard-value">
              <span 
                v-for="(timeKey, idx) in lesson.preferred_time.split(',')" 
                :key="idx" 
                :class="['badge', 'badge-preferred-time', 'd-block', 'mb-1', getPreferredTimeBadgeClass(timeKey.trim())]"
                v-b-tooltip.hover
                :title="preferredTimeFullLabels[timeKey.trim()] || timeKey"
              >
                {{ preferredTimeShortLabels[timeKey.trim()] || timeKey }}
              </span>
            </span>
          </div>

          <!-- Credit / Lessons -->
          <div class="rcard-row">
            <span class="rcard-label">Credit</span>
            <span class="rcard-value">
              <template v-if="lesson.accounting_type === 'credit_based' || btyp === 'b2c'">
                {{lesson.instances_count}} /
                <a href="#" @click.prevent="showCreditHistory(lesson)" class="credit-link">{{lesson.credit}}</a>
              </template>
              <template v-else-if="lesson.accounting_type === 'flexible'">
                <span class="badge badge-info badge-sm"><i class="fas fa-infinity"></i> Flexible</span>
                ({{lesson.instances_count}})
              </template>
              <template v-else-if="lesson.accounting_type === 'lessons_per_month'">
                <span class="badge badge-warning badge-sm"><i class="fas fa-calendar-check"></i> Monthly</span>
                {{ lesson.instances_count_this_month || 0 }} / {{ lesson.lessons_per_month }}
              </template>
              <span v-else class="text-muted">-</span>
            </span>
          </div>
        </div>
      </div>

      <div v-if="!lessons.length" class="text-center text-muted py-4">
        No lessons found.
      </div>
    </div>

    <OjPagination
        class="m-auto"
        :totalItems="total"
        :currentPage="page"
        :perPage="per"
        @pageChanged="pageChanged"
        :key="`pagination-bottom-${page}`"
    />
    <p class="text-center">Zobrazeno {{ lessons.length }} z {{ total }} vyfiltrovaných lekcí</p>
  </div>
  <vyuka-form :lesson="current_lesson" :btyp="btyp" :admin="admin" ref="formVyuka" @save-lesson="handleSaveLesson"></vyuka-form>

 <lesson-instance :lesson="current_lesson" ref="formLessonInstance" :admin="admin" :currentuser="currentuser"></lesson-instance>

 <admin-credit-history-modal ref="creditHistoryModal" />

</template>

<style scoped>
.credit-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 3px;
  transition: all 0.2s ease;
}

.credit-link:hover {
  color: #0056b3;
  background-color: #e7f3ff;
  text-decoration: underline;
}

.badge-sm {
  font-size: 0.7rem;
  padding: 0.2rem 0.45rem;
  display: inline-block;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  white-space: nowrap;
}

.btn-icon {
  font-size: 1.05rem;
  transition: transform 0.2s;
  cursor: pointer;
  text-decoration: none;
}

.btn-icon:hover {
  transform: scale(1.2);
}

.btn-icon-delete {
  color: #dc3545;
}

.btn-icon-delete:hover {
  color: #a71d2a;
}

.btn-add-lesson {
  color: #28a745;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  transition: all 0.2s ease;
}

.btn-add-lesson:hover {
  color: #218838;
  text-decoration: none;
}

.btn-add-lesson i {
  font-size: 0.8rem;
}

/* Disabled styl pro Add new tlačítko */
.btn-add-lesson.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  color: #999;
}

.btn-add-lesson.disabled:hover {
  color: #999;
}

/* Custom purple badge for evening */
.badge-purple {
  background-color: #6f42c1;
  color: white;
}

.badge-preferred-time {
  font-size: 0.75rem;
  padding: 0.3rem 0.6rem;
  font-weight: 600;
  display: inline-block;
}

.badge-status {
  font-weight: bold;
  font-size: 0.7rem;
  min-width: 20px;
  padding: 0.2rem 0.35rem;
  display: inline-block;
  border-radius: 3px;
  line-height: 1;
}

.th-status {
  width: 32px;
  text-align: center;
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.td-status {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

/* ===== Responsive Cards ===== */
.responsive-cards {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.responsive-card {
  background: #fff;
  border: 1px solid rgba(104, 153, 177, 0.3);
  border-radius: 10px;
  overflow: hidden;
}

.rcard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 0.75rem;
  background: #f8f9fa;
  border-bottom: 1px solid #f1f2f6;
  gap: 0.5rem;
}

.rcard-header-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.rcard-student-name {
  font-size: 0.85rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rcard-body {
  padding: 0.6rem 0.75rem;
}

.rcard-row {
  display: flex;
  padding: 0.35rem 0;
  border-bottom: 1px solid #f5f5f5;
  align-items: baseline;
  gap: 0.5rem;
}

.rcard-row:last-child {
  border-bottom: none;
}

.rcard-label {
  font-weight: 600;
  color: #6c757d;
  font-size: 0.78rem;
  min-width: 70px;
  flex-shrink: 0;
}

.rcard-value {
  font-size: 0.85rem;
  color: #333;
  word-break: break-word;
  flex: 1;
}

.rcard-value a {
  color: #0095DA;
  text-decoration: none;
}

.rcard-value a:hover {
  text-decoration: underline;
}

/* Inline cells row (type, lang, level, min side by side) */
.rcard-row-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
}

.rcard-cell {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 60px;
  padding-right: 0.5rem;
}

.rcard-cell .rcard-label {
  min-width: unset;
  margin-bottom: 0.1rem;
}

.rcard-cell .rcard-value {
  font-weight: 600;
}
</style>